import React from 'react';
import PropTypes from 'prop-types';
import AddressSchemaField from './AddressSchemaField';

/**
 * Builds correct input name for address fields.
 *
 * @param string country
 * @param sting name
 * @param string parentName
 */
const getAddressInputName = (country, name, parentName) => {
  // Shared fields keep user values when country (schema) is changed.
  // This effect is achieved because of the same input name.
  const sharedFields = ['addressLine1', 'addressLine2', 'locality', 'postalCode'];

  const fieldBase = parentName ? `${parentName}.${name}` : name;

  if (sharedFields.includes(name)) {
    return fieldBase;
  }

  // Other fields use country-specific input names, thus input values are not
  // shared across different countries.
  return `${fieldBase}.${country}`;
};

const AddressSchemaForm = ({ country, schema, name: parentName }) =>
  Object.keys(schema.properties).map((name) => {
    const property = schema.properties[name];
    const isRequired = schema.required && schema.required.includes(name);
    const fieldName = getAddressInputName(country, name, parentName);

    return (
      <AddressSchemaField
        key={fieldName}
        name={fieldName}
        isRequired={isRequired}
        machineFieldName={name}
        {...property}
      />
    );
  });

AddressSchemaForm.propTypes = {
  country: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    required: PropTypes.arrayOf(PropTypes.string),
    properties: PropTypes.shape(),
  }),
};

export default AddressSchemaForm;
